import { render, staticRenderFns } from "./VstContragentTablePage.vue?vue&type=template&id=627b5772"
import script from "./VstContragentTablePage.vue?vue&type=script&lang=js"
export * from "./VstContragentTablePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports